import React, { useMemo } from "react";

import _ from "lodash";
import { useSelector } from "react-redux";

import { FileSyncOutlined } from "@ant-design/icons";
import { Badge, List, Popover } from "antd";

import { RootState } from "../../../store/root_reducer";

import { ReportGeneratorItem } from "./report_item";
import styles from "./styles.module.scss";

export const ReportSelector: React.FC = () => {
  const reports = useSelector((state: RootState) => state.Reports.generators);
  const tasksCnt = Object.keys(reports).length;

  const menu = useMemo(() => {
    const generatorsIdx = _.keys(reports).reverse();
    return (
      <div className={styles.generators}>
        <List
          dataSource={generatorsIdx}
          renderItem={(generatorIdx) => (
            <List.Item key={`generator-${generatorIdx}`}>
              <ReportGeneratorItem id={generatorIdx} />
            </List.Item>
          )}
        />
      </div>
    );
  }, [reports]);

  return tasksCnt > 0 ? (
    <Popover content={menu} overlayClassName={styles.popover} placement="bottom" trigger={["click"]}>
      <Badge className={styles.badge} count={tasksCnt} size={"small"}>
        <FileSyncOutlined />
      </Badge>
    </Popover>
  ) : (
    <></>
  );
};
